import {AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, Output} from '@angular/core';

/**
 * Generic slide-in drawer / side panel.
 *
 * Usage:
 *   <gp-drawer [(open)]="open" width="460px">
 *     <div drawer-header>...custom header...</div>
 *     ...body content...
 *     <div drawer-footer>...footer actions...</div>
 *   </gp-drawer>
 *
 * The host element is moved to <body> so the overlay + panel are not trapped
 * inside an ancestor stacking context (e.g. the app header) and always cover
 * the whole screen, including the side menu (aside).
 */
@Component({
  selector: 'gp-drawer',
  templateUrl: './drawer.component.html',
  styleUrls: ['./drawer.component.scss']
})
export class DrawerComponent implements AfterViewInit, OnDestroy {

  @Input() public open = false;
  @Input() public width = '460px';
  /** Close the drawer when clicking the backdrop. */
  @Input() public closeOnBackdrop = true;

  @Output() public openChange = new EventEmitter<boolean>();
  @Output() public closed = new EventEmitter<void>();

  constructor(private elementRef: ElementRef) {
  }

  public ngAfterViewInit(): void {
    // Escape any ancestor stacking context by rendering at the body root.
    document.body.appendChild(this.elementRef.nativeElement);
  }

  public ngOnDestroy(): void {
    const el: HTMLElement = this.elementRef.nativeElement;
    if (el && el.parentNode) {
      el.parentNode.removeChild(el);
    }
  }

  @HostListener('document:keydown.escape')
  public onEscape(): void {
    this.close();
  }

  public onBackdropClick(): void {
    if (this.closeOnBackdrop) {
      this.close();
    }
  }

  public close(): void {
    if (!this.open) {
      return;
    }
    this.open = false;
    this.openChange.emit(false);
    this.closed.emit();
  }
}


